import React from 'react';

const PurposeSection = () => {
  return (
    <div className="w-full bg-white">
      {/* Purpose Content Section */}
      <div className="max-w-6xl mx-auto px-8 py-16">
        {/* Section Header */}
        <div className="text-center mb-6">
          <h2 className="text-lg font-medium mb-4" style={{ color: '#6B7280' }}>Our purpose</h2>
          <h1 className="text-5xl font-light leading-tight max-w-4xl mx-auto" style={{ color: '#111827' }}>
            We help people thrive in the brave pursuit of next
          </h1>
        </div>

        {/* Description Text */}
        <div className="max-w-4xl mx-auto">
          <p className="text-lg leading-relaxed" style={{ color: '#374151' }}>
          Kapil Technologies (KCS) is a leading global IT solutions provider with a strong presence in  
            <span className="font-semibold border-b-2 p-2" style={{ color: '#DC2626', borderColor: '#DC2626' }}>
            India, the USA, Indonesia, Malaysia, and Singapore. 
            </span>
            We specialize in end-to-end services, including comprehensive Industry ERP implementations, advanced web and mobile application development, and innovative marketing solutions.   Our team of experts is committed to deliver the unique tailored solutions that drive digital transformation,leveraging the latest technologies to help businesses optimize their operations and maintain a competitive edge.  we ensure seamless delivery of scalable, future-ready solutions
                  </p>
                  
                  
        </div>
      </div>

      {/* Gradient Background Section with Image */}
      <div className="relative w-full h-80 overflow-hidden">
        {/* Image */}
        <div className="absolute inset-0 flex items-center m-auto justify-center rounded-full  h-64 w-[80%]">
          <img 
            src="https://img.freepik.com/free-vector/blurred-green-modern-background_1035-3306.jpg?uid=R117373197&ga=GA1.1.1762279399.1733727878&semt=ais_items_boosted&w=740" 
            alt="Background visual" 
            className="w-full h-full object-cover opacity-60 rounded-xl"
           
          />
        </div>
      </div>
    </div>
  );
};

export default PurposeSection;